<template>
    <div>
        <b-row>
        <b-col md="4" cols="12">
            <ShowSessionMinutesFile :data='data.meeting_minute_id' message="التي تم خلالها الموافقة على حل المنظمة" />
        </b-col> 
        
            <b-col md="4" cols="12">
                <info-card label="اسم المصفي المعين من قبل المُنظمة"
                :value="data.name"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="المنظمة الذي تمَّ اختيارها لتؤول أموال المُنظمة طالبة الحل لها"
                :value="data.alternative_ngo_id ? data.alternative_ngo_id.name_ar : ''"
                />
            </b-col>
        </b-row>
    </div>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import ShowSessionMinutesFile from './ShowSessionMinutesFile.vue'
  import InfoCard from "@/components/InfoCard.vue";  
  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton, ShowSessionMinutesFile
    },
    props: {
        data : Object ,
    },
    data() {
        return {
            file: '',
        }
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
  };
  </script>